import React from 'react';
import { Route, Switch } from 'react-router-dom';
import EditPedidos from './pages/EditPedidos';
import EditSpecialEvent from './pages/EditSpecialEvent';
import FormCupSales from './pages/FormCupSales';
import FormLanches from './pages/FormLanches';
import FormPedidos from './pages/FormPedidos';
import FormPedidosNutri from './pages/FormPedidosNutri';
import FormServicesValue from './pages/FormServicesValue';
import FormSpecialEvent from './pages/FormSpecialEvent';
import ListHolidaysCalendar from './pages/ListHolidaysCalendar';
import ListOrders from './pages/ListOrders';
import ListOrdersNutri from './pages/ListOrdersNutri';
import ListServicesValue from './pages/ListServicesValue';
import ListSpecialEvent from './pages/ListSpecialEvent';

const Routes = () => {
  const route = process.env.MIX_APP_ROUTE;

  return (
    <Switch>
      <Route exact path={`${route}formulario/pedidos/create`} component={FormPedidos} />
      <Route exact path={`${route}formulario/pedidos/nutri/create`} component={FormPedidosNutri} />
      <Route exact path={`${route}formulario/pedidos/:id/edit`} component={EditPedidos} />
      <Route exact path={`${route}formulario/lanches/create`} component={FormLanches} />
      <Route exact path={`${route}formulario/eventoespecial/create`} component={FormSpecialEvent} />
      <Route exact path={`${route}formulario/eventoespecial/:id/edit`} component={EditSpecialEvent} />
      <Route exact path={`${route}formulario/venda/copos/create`} component={FormCupSales} />
      <Route exact path={`${route}calendario/feriados`} component={ListHolidaysCalendar} />
      <Route exact path={`${route}pedidos/listagem`} component={ListOrders} />
      <Route exact path={`${route}pedidos/eventoespecial/listagem`} component={ListSpecialEvent} />
      <Route exact path={`${route}nutri/pedidos/listagem`} component={ListOrdersNutri} />
      <Route exact path={`${route}servicos/valores/create`} component={FormServicesValue} />
      <Route exact path={`${route}servicos/valores/listagem`} component={ListServicesValue} />
    </Switch>
  )
}

export default Routes;
